import { render, staticRenderFns } from "./WaitHost.vue?vue&type=template&id=b3163a44&scoped=true&"
import script from "./WaitHost.vue?vue&type=script&lang=js&"
export * from "./WaitHost.vue?vue&type=script&lang=js&"
import style0 from "./WaitHost.vue?vue&type=style&index=0&id=b3163a44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3163a44",
  null
  
)

export default component.exports